// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20P4t","colMin":"styles_colMin__pYTwy"};